import * as hotjarTracking from './tools/hotjar';

/**
 * Tag a recording.
 */
export const tagRecording = ({ name }: { name: string }): void => {
  hotjarTracking.tagRecording(name);
};
